module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2a",
    attrs: {
      "id": "int-1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#int1"
    }
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("F")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW FOODS ARE AS SATISFYING")]), _vm._v(" and flavorful as delicious homemade soups and stews. They’re wholesome and comforting. They’re the heart and soul of the kitchen; they restore our spirit. The glorious aroma of a simmering soup or sumptuous stew is guaranteed to whet appetites and bring folks into the kitchen to check on what’s cooking for dinner.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("The varieties of soups and stews are nearly endless, as you’ll find with the more than 1,001 creative and healthful recipes in "), _c('i', [_vm._v("1,001 Delicious Soups and Stews")]), _vm._v(". Fourteen delectable chapters are filled with stocks, chowders, chilis, supper soups, vegetarian soups and stews, meat, poultry and seafood stews, and more. There are recipes for comfort foods, old-fashioned favorites, recipes with a foreign flair, vegetarian recipes, and recipes that highlight new food trends. You’ll find hearty full-flavored soups and stews, perfect for crisp fall and frosty winter seasons, and light, lovely soups and stews for the fresh days of spring and the sultry summer season. There’s a soup or stew recipe for every occasion, whether a family meal, a festive celebration, or a casual evening with friends.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Included in "), _c('a', {
    attrs: {
      "href": "#/Chapter01"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" are 18 recipes for homemade stocks to use for best flavor in soups and stews. Stocks are very easy to make, as they simmer untended to flavorful goodness. They can be made ahead in large quantities and frozen for convenient use later. Of course, canned or packaged broths can be substituted in any recipe.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")]), _vm._v(", Breads and Accompaniments, has many new recipes and offers a bounty of recipes for breads, biscuits, muffins, and pestos to enhance your soup and stew dining experiences.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("You’ll enjoy "), _c('span', {
    attrs: {
      "href": "#/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")]), _vm._v(", Menu Magic, which presents menus for 10 complete meals for family dinners or casual entertaining. Each menu includes preparation tips, plus nutritional data for the entire menu as well as for individual recipes. We hope this chapter will be a helpful guide in planning balanced and delicious repasts.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("Recipes have been carefully created for fabulous flavors, using high-quality, healthy ingredients that are readily available in your local supermarket—no special shopping excursions needed! Recipes are designed for cooking ease, requiring no special cooking skills or gourmet kitchen equipment. We’ve taken advantage of the fast/slow convenience that microwave ovens and slow cookers offer, with dishes that cook in minutes and others that simmer all day. Preparation and cooking times are streamlined in every recipe, complementing today’s busy lifestyles. More than 490 recipes can be prepared and cooked in no more than 45 minutes, and often in much less time. And, as soups and stews are perfect candidates for advance preparation, you can make them ahead to refrigerate or freeze—a great do-ahead bonus!")])]), _vm._v(" "), _c('p', {
    staticClass: "h3a"
  }, [_c('span', [_vm._v("NEW IN THIS EDITION")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_vm._v("The soup and stew recipes that can be prepared in 45 minutes or less have a special designation. We know busy lifestyles allow precious little cooking time for many of us, so these recipes are designed to get you in and out of the kitchen as quickly and effortlessly as possible.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("For easy identification, these recipes will have this symbol "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/45.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "22",
      "src": "images/45.jpg",
      "width": "22"
    }
  })]), _vm._v(". If the recipe requires baking, refrigeration, or freezing in addition to the actual preparation time, the symbols "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/bake.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "22",
      "src": "images/bake.jpg",
      "width": "22"
    }
  })]), _vm._v(", for baking, and "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/refrig.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "22",
      "src": "images/refrig.jpg",
      "width": "22"
    }
  })]), _vm._v(", for refrigeration/freezing, will also appear.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("The recipes in the Vegetarian Soups and Stews chapters are coded as follows so you can quickly tell if they are vegan, lacto-ovo vegetarian, lacto-vegetarian, or ovo-vegetarian.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangi"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/v.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "22",
      "src": "images/v.jpg",
      "width": "22"
    }
  })]), _vm._v(" (vegan)—Recipes contain only plant-based food, with no dairy products or eggs.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangi"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/lo.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "22",
      "src": "images/lo.jpg",
      "width": "22"
    }
  })]), _vm._v(" (lacto-ovo vegetarian)—Recipes contain dairy products and eggs.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangi"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/l.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "22",
      "src": "images/l.jpg",
      "width": "22"
    }
  })]), _vm._v(" (lacto vegetarian)—Recipes contain dairy products, but no eggs.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangi"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/o.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "22",
      "src": "images/o.jpg",
      "width": "22"
    }
  })]), _vm._v(" (ovo vegetarian)—Recipes contain eggs, but no dairy products.")])]), _vm._v(" "), _c('p', {
    staticClass: "h3aa"
  }, [_c('span', [_vm._v("NUTRITIONAL INFORMATION")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_vm._v("The recipes in this book have been developed to be healthy as well as delicious. Hundreds of the recipes are low in carbohydrates, not exceeding 30 to 35 grams per serving, which is recommended for a "), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("healthy maintenance carbohydrate diet. All of the recipes are also low in fat and calories. In accordance with American Heart Association guidelines, very few recipes in this book exceed 30 percent of calories from fat, and almost all adhere to the following nutritional criteria.")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_c('b', [_vm._v("Type of Recipe Maximum Amounts per Serving")])])]), _vm._v(" "), _c('p', {
    staticClass: "imaget"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "376",
      "src": "images/page_ix_1.jpg",
      "width": "644"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_vm._v("Specific nutritional information is provided for each recipe (not including variations). The nutritional analyses are derived by using computer software highly regarded by nutritionists and dietitians, but they are meant to be used only as guidelines. Results may vary slightly depending upon the brand or manufacturer of an ingredient used.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Ingredients noted as “optional” or “to taste” or “as garnish” are not included in the nutritional analyses. When alternate choices or amounts of ingredients are given, the ingredient or amount listed first is used for analysis.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Other factors that can affect the accuracy of nutritional data include variability in sizes, weights, and measures of fruits, vegetables, and other foods. There is also a possible 20 percent error factor in the nutritional labeling of prepared foods.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("If you have any health problems that impose strict dietary requirements, it is important to consult a physician, dietitian, or nutritionist before using recipes in this or any other cookbook.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7537d72c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Introduction.vue
// module id = 72
// module chunks = 0